import { action, autorun, computed, observable } from 'mobx';
import { directoryStore } from './DirectoryStore';
import { ZipApi } from '../lib/ZipApi';
import { DataSyncExecution } from '../types/DataSyncExecution';
import { DataTablePagingProps } from '@zaiusinc/hera';
import { DataSyncItem } from '../types/DataSyncItem';

export default class DataSyncDetailsStore {
  @observable public loading = false;
  @observable public executions: DataSyncExecution[] = [];
  @observable public dataSync?: DataSyncItem;

  private readonly maxTotal = 10000;
  @observable private _executionsPaging: DataTablePagingProps = {rowStart: 1, rowCount: 10, total: this.maxTotal};

  constructor(public dataSyncId: string) {
    autorun(() => {
      if (directoryStore.trackerId) {
        this.fetch();
      }
    });
  }

  public async fetch() {
    try {
      this.loading = true;
      this.dataSync = undefined;
      const {dataSync} = (await ZipApi.getDataSync(this.dataSyncId));
      this.dataSync = dataSync;
    } finally {
      this.loading = false;
    }
  }

  @action
  public async getExecutions() {
    try {
      this.loading = true;
      this.executions = [];

      const offset = Math.floor(this._executionsPaging.rowStart / this._executionsPaging.rowCount);
      const response = await ZipApi.listDataSyncExecutions(
        this.dataSyncId,
        offset,
        this._executionsPaging.rowCount
      );

      this.executions = response.executions || [];

      if (this.executions.length < this._executionsPaging.rowCount) {
        this._executionsPaging.total = (this._executionsPaging.rowStart - 1) + this.executions.length;
      } else {
        this._executionsPaging.total = this.maxTotal;
      }
    } finally {
      this.loading = false;
    }
  }

  @computed
  public get executionsPaging() {
    return this._executionsPaging;
  }

  @action
  public async setExecutionsPaging(paging: DataTablePagingProps) {
    if (paging.rowStart <= 0) {
      paging.rowStart = 1;
    }
    this._executionsPaging = paging;
    await this.getExecutions();
  }
}
